import { render, staticRenderFns } from "./IpSplitPopup.vue?vue&type=template&id=3a574fc3&scoped=true&"
import script from "./IpSplitPopup.vue?vue&type=script&lang=js&"
export * from "./IpSplitPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a574fc3",
  null
  
)

export default component.exports